import { Panel } from 'primereact/panel'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchData, addmsgdata } from '../reduxactions/donorrsactions/DonorChatAction';
import { RootState } from '../reducers';
import { useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { GFNButton } from '../ui';

const DonorChat = () => {
    const uid = window.sessionStorage.getItem('uid');
    const usertype = window.sessionStorage.getItem('usertype');

    const dispatch = useDispatch()
    const [queryParams, setQueryParams] = useState(null);
    const location = useLocation();
    const data = useSelector((state: RootState) => state.donorchat.data);
    const msgdata = useSelector((state: RootState) => state.donorchat.msgdata);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("donationID") as any);
    }, [location]);
    const { donationID } = useParams();
    // To get data
    const fetchDataAsync = async () => {
        try {
            console.log(donationID, "did")
            await dispatch(fetchData(uid, usertype, donationID) as any);

        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch])

    const [message, setMessage] = useState<string>('');
    const toast = useRef(msgdata);

    const AddsMessage = async () => {
        try {
            await dispatch(addmsgdata(uid, message, donationID) as any);
            toast.current.show({ severity: 'success', summary: 'Success', detail: msgdata, life: 3000 })

            setMessage('');
        } catch (error) {
            console.error('Error fetching data', error)
        }
        fetchDataAsync();
    }
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/donorcommunication.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        {/* <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">
                                    <div className="col-9">
                                        <h1>Communication</h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{

                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section> */}
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Communication</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <section className="content">
                            <div className="container-fluid">
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="card direct-chat direct-chat-primary">
                                            <Panel header="Direct Chat">
                                                {data.map((response: any) =>

                                                    <div className="grid">
                                                        <div className="col-2">
                                                            <p>{response.name}, {response.date} </p>
                                                        </div>
                                                        <div className="col-9">
                                                            <p>{response.msg} </p>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="card-footer">
                                                    <div className="grid">
                                                        <div className='col-10'>
                                                            <InputText data-testid="chat-input" value={message} placeholder="Type Message ..." className="w-full mb-10" onChange={(e) => setMessage(e.target.value)} />
                                                        </div>
                                                        <span className="input-group-btn">
                                                            <div className='col-2'>
                                                                {/* <Button severity="info" icon="pi pi-send" data-testid="chat-btn" rounded outlined onClick={AddsMessage} /> */}
                                                                <GFNButton label="Send" icon="pi pi-send" data-testid="chat-btn" rounded outlined onClick={AddsMessage} buttonType="secondary" />
                                                                <Toast ref={toast} >
                                                                    <Message severity="success" content={msgdata} />
                                                                </Toast>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </Panel>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DonorChat

